import { Share } from 'types';

type GetCoOwnerEncumberedSharesCountProps = {
  share: Share;
};

export const getCoOwnerEncumberedSharesCount = ({
  share,
}: GetCoOwnerEncumberedSharesCountProps): number => {
  if (!share?.encumbrances?.length) return 0;

  return share.encumbrances.reduce(
    (acc, encumbrance) => acc + (encumbrance.to - encumbrance.from + 1),
    0
  );
};
